import React from 'react';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { useXP } from '@/hooks/useXP';

const LEVEL_ICONS: Record<string, string> = {
  Bronze: '🥉',
  Silver: '🥈',
  Gold: '🥇',
  Platinum: '💎',
  Diamond: '💠',
  Elite: '👑',
};

export const LevelUpOverlay: React.FC = () => {
  const { showLevelUp, newLevel, closeLevelUp } = useXP();

  if (!newLevel) return null;

  const icon = LEVEL_ICONS[newLevel.name] || '🥉';

  return (
    <Dialog open={showLevelUp} onOpenChange={closeLevelUp}>
      <DialogContent className="max-w-sm">
        <div className="text-center space-y-4 py-6">
          <div className="text-8xl animate-scale-in">{icon}</div>
          <div className="space-y-2">
            <h2 className="text-3xl font-bold text-primary">Level Up!</h2>
            <p className="text-xl text-foreground">
              You're now <span className="font-bold">{newLevel.name}</span>
            </p>
            <p className="text-sm text-muted-foreground">
              Level {newLevel.level}
            </p>
          </div>
          <Button 
            onClick={closeLevelUp} 
            className="w-full"
            size="lg"
          >
            Continue
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
